module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Prod_web-client/node_modules/readable-stream/passthrough.js
// module id = rr9E
// module chunks = 15